import React from 'react'

export function Checkbox({ className = '', checked, onChange, ...props }) {
  return (
    <input
      className={`checkbox ${className}`}
      type='checkbox'
      checked={checked}
      onChange={onChange}
      {...props}
    />
  )
}
